"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChromeExtensionInstalled = void 0;
const PostMessageTransport_1 = require("../transports/PostMessageTransport");
exports.isChromeExtensionInstalled = PostMessageTransport_1.PostMessageTransport.isAvailable();
//# sourceMappingURL=is-extension-installed.js.map